import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-gov-site-link',
  imports: [MatIconModule, MatInputModule],
  templateUrl: './gov-site-link.component.html',
  styleUrls: ['./gov-site-link.component.scss'],
})
export class GovSiteLinkComponent {
  public noticeOpen = false;
  public everOpened = false;

  public toggleNotice($event: Event): void {
    $event.preventDefault();
    this.noticeOpen = !this.noticeOpen;
    if (!this.everOpened) {
      this.everOpened = true;
    }
  }
}
